// ABOUTME: Standardized trigger button for dropdown menus (three dots icon)
// ABOUTME: Use as label prop in CDropdown for consistent menu button styling

import { MoreVertical } from "lucide-react"
import type { FC } from "react"
import useDevice from "@shared/hooks/useDevice"

interface CMenuTriggerProps {
  className?: string
  size?: "sm" | "md" | "lg"
  variant?: "default" | "gray"
  disabled?: boolean
}

const sizeClasses = {
  sm: "w-5 h-5",
  md: "w-[22px] h-[22px]",
  lg: "w-6 h-6",
}

const iconSizes = {
  sm: "h-3",
  md: "h-3.5",
  lg: "h-4",
}
const variantClasses = {
  default: {
    base: "bg-white",
    hover: "hover:bg-gray-50",
  },
  gray: {
    base: "bg-customGray-100",
    hover: "hover:bg-gray-200",
  },
}

// On touch there is no hover to reveal the affordance, and a chip on every card
// reads as clutter rather than as a control — so touch gets the bare dots. The
// rule lives here rather than in the call sites, which is what let the calendar
// cards and the meal rows drift apart.
const touchStyle = {
  base: "bg-transparent",
  hover: "",
}

export const CMenuTrigger: FC<CMenuTriggerProps> = ({
  className = "",
  size = "md",
  variant = "default",
  disabled = false,
}) => {
  const { isTouchDevice } = useDevice()
  const variantStyle = isTouchDevice ? touchStyle : variantClasses[variant]

  return (
    <span
      className={`flex items-center justify-center shrink-0 rounded-md ${sizeClasses[size]} ${variantStyle.base} ${
        disabled ? "cursor-not-allowed text-gray-400" : `cursor-pointer ${variantStyle.hover}`
      } ${className}`}
      role={disabled ? "button" : undefined}
      aria-disabled={disabled || undefined}
    >
      <MoreVertical className={`${disabled ? "text-gray-400" : "text-black"} ${iconSizes[size]}`} />
    </span>
  )
}
